import { useMemo } from 'react';
import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { PaymentsTableInstances } from '../../utils';
import { GenerateColumnsFn, useGenerateColumns } from '../use-generate-columns';

type GenerateColumnsHOF<T extends NonNullable<unknown>> = (options: {
  showPayoutDescriptor: boolean;
}) => GenerateColumnsFn<T>;

export const useColumnsWithPayoutDescriptor = <T extends NonNullable<unknown>>({
  forPrint,
  hideLocationNameColumn = false,
  generateColumns,
  tableName,
}: {
  forPrint: boolean;
  hideLocationNameColumn?: boolean;
  generateColumns: GenerateColumnsHOF<T>;
  tableName: PaymentsTableInstances;
}) => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();

  const { getFeatureFlagValue } = useAppFlagStore();
  const showPayoutDescriptor = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.PayoutDescriptorColumn,
    locationIds: locationIds,
  });
  const generateTableColumns = useMemo(() => generateColumns({ showPayoutDescriptor }), [showPayoutDescriptor]);

  const columns = useGenerateColumns<T>(generateTableColumns, forPrint, tableName, {
    hideLocationNameColumn,
  });
  return { columns, showPayoutDescriptor };
};
export const useColumnsWithPayoutDescriptorLegacy = <T extends NonNullable<unknown>>({
  forPrint,
  hideLocationNameColumn = false,
  generateColumns,
  tableName,
}: {
  forPrint: boolean;
  hideLocationNameColumn?: boolean;
  generateColumns: GenerateColumnsHOF<T>;
  tableName: PaymentsTableInstances;
}) => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();

  const { getFeatureFlagValue } = useAppFlagStore();
  const showPayoutDescriptor = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.PayoutDescriptorColumn,
    locationIds: locationIds,
  });
  const generateTableColumns = useMemo(() => generateColumns({ showPayoutDescriptor }), [showPayoutDescriptor]);

  const columns = useGenerateColumns<T>(generateTableColumns, forPrint, tableName, {
    hideLocationNameColumn,
  });
  return { columns, showPayoutDescriptor };
};
